<div class="package-table-container">
  <ng-container *ngIf="!isLoading; else packageTableSkeleton">
    <div class="table-scroll-wrapper" #tableScrollWrapper>
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="mat-mdc-table"
        data-testid="packages-table"
      >
        <!-- Package Name Column -->
        <ng-container matColumnDef="package_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 280px">
            Package
            <img [src]="getSortIcon('package_name')" alt="sort" class="sort-icon" />
          </th>
          <td mat-cell *matCellDef="let package">
            <div class="package-name-cell">
              <span class="package-name p3 text-semibold">{{ package.package_name }}</span>
              <span
                class="feature-count p5 text-underline"
                [matTooltip]="package.features_tooltip"
                matTooltipClass="package-table-tooltip"
                matTooltipPosition="below"
              >
                {{ package.features?.length || 0 }} features
              </span>
              <span class="created-date p7"
                >Created on {{ package.created_at | date: 'd MMMM, y' }}</span
              >
            </div>
          </td>
        </ng-container>

        <!-- Wash Types Column -->
        <ng-container matColumnDef="wash_types">
          <th mat-header-cell *matHeaderCellDef style="min-width: 200px">Type</th>
          <td mat-cell *matCellDef="let package">
            <div class="wash-types p7">
              <span *ngIf="showAddOnTypePill(package)" class="wash-type-tag wash-type-add-on"
                >Add On</span
              >
              <span
                *ngFor="let wash_type of washTypesForTypeColumn(package)"
                class="wash-type-tag"
                [ngClass]="{
                  'wash-type-single': wash_type === 'single_wash',
                  'wash-type-monthly': wash_type === 'monthly_membership',
                  'wash-type-detailing': wash_type === 'detailing',
                }"
              >
                {{ getWashTypeLabelForTable(wash_type) }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Wash Count Column -->
        <ng-container matColumnDef="wash_count">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px">Wash count</th>
          <td mat-cell *matCellDef="let package">
            <span class="p7">{{ getWashCountLabelForTable(package) }}</span>
          </td>
        </ng-container>

        <!-- Package Status Column -->
        <ng-container matColumnDef="package_status">
          <th mat-header-cell *matHeaderCellDef style="min-width: 125px">Status</th>
          <td mat-cell *matCellDef="let package">
            <span
              [ngClass]="{
                'status-active': package.package_status,
                'status-inactive': !package.package_status,
              }"
            >
              {{ package.package_status ? 'Active' : 'Inactive' }}
            </span>
          </td>
        </ng-container>

        <!-- Locations Column -->
        <ng-container matColumnDef="locations">
          <th mat-header-cell *matHeaderCellDef style="min-width: 170px">Location</th>
          <td mat-cell *matCellDef="let package">
            <div
              class="location-cell p5"
              *ngIf="package.locations?.length > 0"
              [matTooltip]="package.locations_tooltip"
              matTooltipClass="package-table-tooltip"
              matTooltipPosition="below"
            >
              {{ package.locations?.length }}
              {{ package.locations?.length === 1 ? 'location' : 'locations' }}
            </div>
          </td>
        </ng-container>

        <!-- Single List Price Column -->
        <ng-container matColumnDef="single_list_price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px">
            List Price
            <img [src]="getSortIcon('single_list_price')" alt="sort" class="sort-icon" />
          </th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ displaySinglePrice(package, 'single_list_price') | currency }}
          </td>
        </ng-container>

        <!-- Single Strikeoff Price Column -->
        <ng-container matColumnDef="single_strikeoff_price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 185px">
            Strike-Off Price
            <img [src]="getSortIcon('single_strikeoff_price')" alt="sort" class="sort-icon" />
          </th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ displaySinglePrice(package, 'single_strikeoff_price') | currency }}
          </td>
        </ng-container>

        <!-- Monthly List Price Column -->
        <ng-container matColumnDef="monthly_list_price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 167px">
            Monthly Price
            <img [src]="getSortIcon('monthly_list_price')" alt="sort" class="sort-icon" />
          </th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ coerceCurrencyAmount(package.monthly_list_price) | currency }}
          </td>
        </ng-container>

        <!-- Monthly Strikeoff Price Column -->
        <ng-container matColumnDef="monthly_strikeoff_price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 260px">
            Monthly Strike-Off Price
            <img [src]="getSortIcon('monthly_strikeoff_price')" alt="sort" class="sort-icon" />
          </th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ coerceCurrencyAmount(package.monthly_strikeoff_price) | currency }}
          </td>
        </ng-container>

        <!-- Family Plan Column -->
        <ng-container matColumnDef="family_eligible">
          <th mat-header-cell *matHeaderCellDef style="min-width: 130px">Family Plan</th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ package.family_eligible ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <!-- License Plate Required Column -->
        <ng-container matColumnDef="license_plate_needed">
          <th mat-header-cell *matHeaderCellDef style="min-width: 200px">License Plate Required</th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ package.license_plate_needed ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <!-- Updated At Column -->
        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 190px">
            Last Configured
            <img [src]="getSortIcon('updated_at')" alt="sort" class="sort-icon" />
          </th>
          <td mat-cell *matCellDef="let package" class="p5">
            {{ package.updated_at | date: 'd MMM, y' }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px">Actions</th>
          <td mat-cell *matCellDef="let package">
            <app-package-row-actions
              [testId]="'package-row-actions-' + package.id"
              [items]="rowActionItems"
              ariaLabel="Package actions"
              (menuOpened)="setCurrentPackage(package)"
              (action)="onRowAction($event)"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [attr.data-testid]="'packages-table-row-' + row.id"
        ></tr>
      </table>
    </div>
  </ng-container>
</div>

<ng-template #packageTableSkeleton>
  <div class="table-scroll-wrapper" #tableScrollWrapper>
    <div class="table-skeleton">
      <div class="table-skeleton-header">
        <div class="th" style="min-width: 280px">Package</div>
        <div class="th" style="min-width: 200px">Type</div>
        <div class="th" style="min-width: 125px">Status</div>
        <div class="th" style="min-width: 170px">Location</div>
        <div class="th" style="min-width: 140px">List Price</div>
        <div class="th" style="min-width: 185px">Strike-Off Price</div>
        <div class="th" style="min-width: 147px">Monthly Price</div>
        <div class="th" style="min-width: 221px">Strike-Off Price</div>
        <div class="th" style="min-width: 130px">Family Plan</div>
        <div class="th" style="min-width: 205px">Family Plan Price</div>
        <div class="th" style="min-width: 200px">License Plate Required</div>
        <div class="th" style="min-width: 190px">Last Configured</div>
        <div class="th" style="min-width: 100px">Actions</div>
      </div>
      <div class="table-skeleton-body">
        <div class="tr" *ngFor="let _ of skeletonRows">
          <div class="td" style="min-width: 280px; display: flex; flex-direction: column; gap: 6px">
            <div class="shimmer-line w-180"></div>
            <div class="shimmer-line w-120"></div>
            <div class="shimmer-line w-140"></div>
          </div>
          <div class="td" style="min-width: 200px; display: flex; gap: 8px">
            <div class="shimmer-pill w-90"></div>
            <div class="shimmer-pill w-140"></div>
          </div>
          <div class="td" style="min-width: 125px"><div class="shimmer-pill w-80"></div></div>
          <div class="td" style="min-width: 170px"><div class="shimmer-line w-120"></div></div>
          <div class="td" style="min-width: 140px"><div class="shimmer-line w-80"></div></div>
          <div class="td" style="min-width: 185px"><div class="shimmer-line w-110"></div></div>
          <div class="td" style="min-width: 147px"><div class="shimmer-line w-100"></div></div>
          <!-- <div class="td" style="min-width: 221px;"><div class="shimmer-line w-150"></div></div> -->
          <!-- <div class="td" style="min-width: 130px;"><div class="shimmer-line w-60"></div></div> -->
          <!-- <div class="td" style="min-width: 205px;"><div class="shimmer-line w-120"></div></div> -->
          <!-- <div class="td" style="min-width: 200px;"><div class="shimmer-line w-140"></div></div> -->
          <!-- <div class="td" style="min-width: 190px;"><div class="shimmer-line w-120"></div></div> -->
          <!-- <div class="td" style="min-width: 100px;"><div class="shimmer-circle small"></div></div> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>
